// extracted by mini-css-extract-plugin
module.exports = {"points":"ProductPoints_points__GXtxV","ploom":"ProductPoints_ploom__owsxf","pointsQuantity":"ProductPoints_pointsQuantity__35Oes"};